import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'

import PublicRoot from './encapsulation/PublicRoot.tsx'
import PrivateRoot from './encapsulation/PrivateRoot.tsx'

import ProjectScreen from './screens/ProjectScreen.tsx'
import UserManagementScreen from './screens/UserManagementScreen.tsx'
import OrganizationManagementScreen from './screens/OrganizationManagementScreen.tsx'
import UnassignedBoltsScreen from './screens/UnassignedBoltsScreen.tsx'
import ManufacturedBoltsScreen from './screens/ManufacturedBoltsScreen.tsx'
import AllSensorsScreen from './screens/AllSensorsScreen.tsx'
import SensorDetailScreen from './screens/SensorDetailScreen.tsx'
import OrganizationDevicesScreen from './screens/OrganizationDevicesScreen.tsx'
import WorkfilesScreen from './screens/WorkfilesScreen.tsx'
import AllCalibrationRodsScreen from './screens/AllCalibrationRodsScreen.tsx'
import DashboardScreen from './screens/DashboardScreen.tsx'
import BoltConnectionScreen from './screens/BoltConnectionScreen.tsx'
import BoltScreen from './screens/BoltScreen.tsx'
import CreateUserScreen from './screens/CreateUserScreen.tsx'
import UserProfileScreen from './screens/UserProfileScreen.tsx'
import CreateOrganizationScreen from './screens/CreateOrganizationScreen.tsx'
import OrganizationProfileScreen from './screens/OrganizationProfileScreen.tsx'
import ServiceWindowScreen from './screens/ServiceWindowScreen.tsx'

const START_PATH = '/home'

const router = createBrowserRouter([
    {
        path: '/welcome' + START_PATH,
        element: <PublicRoot />,
    },
    {
        path: '/',
        element: <PrivateRoot />,
        children: [
            {
                path: '/',
                index: true,
                element: <Navigate to={START_PATH} replace />,
            },
            {
                path: START_PATH,
                element: <DashboardScreen />,
            },
            {
                path: '/organizations',
                element: <OrganizationManagementScreen />,
            },
            {
                path: '/organizations/:orgProfileId',
                element: <OrganizationProfileScreen />,
            },
            {
                path: '/organizations/create',
                element: <CreateOrganizationScreen />,
            },
            {
                path: '/users',
                element: <UserManagementScreen />,
            },
            {
                path: '/users/:userProfileId',
                element: <UserProfileScreen />,
            },
            {
                path: '/users/create',
                element: <CreateUserScreen />,
            },
            {
                path: '/manufactured',
                element: <ManufacturedBoltsScreen />,
            },
            {
                path: '/unassigned',
                element: <UnassignedBoltsScreen />,
            },
            {
                path: '/sensors',
                element: <AllSensorsScreen />,
            },
            {
                path: '/sensors/:sensorId',
                element: <SensorDetailScreen />,
            },
            {
                path: '/devices',
                element: <OrganizationDevicesScreen />,
            },
            {
                path: '/workfiles',
                element: <WorkfilesScreen />,
            },
            {
                path: '/service-window',
                element: <ServiceWindowScreen />,
            },
            {
                path: '/service-window/:serviceWindowId',
                element: <ServiceWindowScreen />,
            },
            {
                path: '/calibration-rods',
                element: <AllCalibrationRodsScreen />,
            },
            {
                path: '/project/:rootId/new/:parentId',
                element: <ProjectScreen />,
            },
            {
                path: '/project/new',
                element: <ProjectScreen />,
            },
            {
                path: '/project/:projectId',
                element: <ProjectScreen />,
            },
            {
                path: '/connection/:rootId/new/:parentId',
                element: <BoltConnectionScreen />,
            },
            {
                path: '/connection/:boltConnectionId',
                element: <BoltConnectionScreen />,
            },
            {
                path: '/bolt/:boltId',
                element: <BoltScreen />,
            },
        ],
    },
])

export default function Router() {
    return <RouterProvider router={router} />
}
